import { render, staticRenderFns } from "./MagicCubePreview.vue?vue&type=template&id=c25edd58&scoped=true"
import script from "./MagicCubePreview.vue?vue&type=script&lang=js"
export * from "./MagicCubePreview.vue?vue&type=script&lang=js"
import style0 from "./MagicCubePreview.vue?vue&type=style&index=0&id=c25edd58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25edd58",
  null
  
)

export default component.exports